import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';
import scopeImage from '../../../Assets/ResearchLabs/GSERL/GSERL-Circular.jpg';

const { Paragraph, Title } = Typography;

const GserlScope = () => (
  <section className="scope-section">
    <div className="scope-section-inner">
      <Row gutter={[72, 40]} align="middle" justify="space-between">
        <Col xs={24} md={14}>
          <Title level={2} className="scope-title">Scope</Title>
          <Divider className="ncgsa-divider" />

          <Paragraph className="scope-description">
            GNSS and Space Education Research Lab (GSERL) is dedicated to producing cutting-edge research outputs and building human-resource capacity in Global Navigation Satellite Systems and space.
          </Paragraph>
          <Paragraph className="scope-description">
            Major research activities include transport monitoring systems, livestock management using GNSS, jamming and spoofing, GNSS–INS integration, and GNSS augmentation systems. In collaboration with the international GNSS community and local resources, GSERL aims to develop significant tools and techniques at the national level to help harvest the numerous benefits of GNSS and space applications.
          </Paragraph>
          <Paragraph className="scope-description">
            GSERL also develops methods to spread national awareness of space science, technology, and their applications through schools, seminars, events, workshops, training, competitions, and public gatherings for all age groups. The lab brings together all segments of society to realize the potential of space science and technology for socio-economic and technological development.
          </Paragraph>
        </Col>

        <Col xs={24} md={9}>
          <div className="scope-image-wrap">
            <img src={scopeImage} alt="GNSS satellite above Earth" className="scope-image" />
          </div>
        </Col>
      </Row>
    </div>
  </section>
);

export default GserlScope;
